module.exports = "/_next/static/images/Hero-xs@2x-6f09f8978838a8a964da4caf092dfc2f.webp";